import { curry, sum } from 'rambda'

export const average = numbers => sum(numbers) / numbers.length

export const isGt = curry((number1, number2) => number1 < number2)
// export const isGte = curry((number1, number2) => number1 <= number2)

export const isLt = curry((number1, number2) => number1 > number2)
// export const isLte = curry((number1, number2) => number1 >= number2)

// export const toFixed = digits => number => Number(Number(number).toFixed(digits))
